import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import moment from 'moment';
import { colorScheme } from '@/constants/constants';

// define component proprs

export default /*#__PURE__*/_defineComponent({
  __name: 'LineChart',
  props: {
  chartData: {
    type: Object,
    required: true,
  },
  title: {
    type: String
  },
  yAxisTitle: {
    type: String
  },
  subTitle: {
    type: String
  },
  height: {
    type: Number
  },
  width: {
    type: Number
  },
  color: {
    type: String,
    default: 'blue'
  }
},
  setup(__props) {

const props = __props;



// set up chart layout and options
const chartOptions = ref({
  title: {
    text: props.title || '',
  },
  subtitle: {
    text: props.subTitle,
    style: {
      color: '#9CA3AF'
    }
  },
  chart: {
    backgroundColor: null,
    style: {
      fontFamily: 'Source Sans Pro'
    },
    width: props.width,
    height: props.height || 300,
    marginRight: 20
  },
  legend: {
    enabled: false
  },
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value:%d %b %Y}',
    }
  },
  yAxis: [{
    gridLineColor: '#E3E3E3',
    title: {
      text: props.yAxisTitle
    }
  }],
  colors: [colorScheme[props.color]],
  series: props.chartData,
  tooltip: {
    shadow: false,
    style: {
      fontSize: 14
    },
    // eslint-disable-next-line object-shorthand
    formatter: function (): any {
      return `Waarde: <b>${this.y}</b> op <b>${moment(this.x).format('DD MMM YYYY')}</b>`;
    }
  },
  credits: {
    enabled: false
  },
});


return (_ctx: any,_cache: any) => {
  const _component_highcharts = _resolveComponent("highcharts")!

  return (_openBlock(), _createBlock(_component_highcharts, {
    options: chartOptions.value,
    ref: "chart"
  }, null, 8, ["options"]))
}
}

})